import { goBackMessage } from 'services/router/router.restate'
import { useDispatchHook } from 'state/store'

export function useGoBack() {
  const dispatch = useDispatchHook()
  return function () {
    dispatch(goBackMessage())
  }
}
